import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';

import { CommunicationWorkflow } from '@pwp-common';

import { CommunicationWorkflowService } from '../../../../services/communication/communication-workflow/communication-workflow.service';
import {
  getObjAutocompleteFormControlBaseProviders,
  ObjAutocompleteFormControlBase,
} from '../../../generic/abstract-classes/obj-autocomplete-form-control-base';

@Component({
  selector: 'app-communication-workflow-autocomplete',
  templateUrl: './communication-workflow-autocomplete.component.html',
  styleUrls: ['./communication-workflow-autocomplete.component.scss'],
  imports: [AutoCompleteModule, CommonModule, FormsModule, MatIconModule, ReactiveFormsModule, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [...getObjAutocompleteFormControlBaseProviders(() => CommunicationWorkflowAutocompleteComponent)],
  standalone: true,
})
export class CommunicationWorkflowAutocompleteComponent
  extends ObjAutocompleteFormControlBase<CommunicationWorkflow>
  implements OnInit
{
  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public communicationWorkflowService: CommunicationWorkflowService,
  ) {
    super(changeDetectorRef);
  }

  public defineAllOptions(): Observable<CommunicationWorkflow[]> {
    return this.communicationWorkflowService.getDocsArray();
  }
}
